// extracted by mini-css-extract-plugin
export default {"navMenu":"ProjectsConstructorNavMenu_navMenu__cXiTw","title":"ProjectsConstructorNavMenu_title__0f27X","navMenu__mobile":"ProjectsConstructorNavMenu_navMenu__mobile__AdmEk"};